<template>

  <div id="app" >
    <!--
    <div id="nav">
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
  </div>-->
  <router-view/>
</div>
</template>
<script>
require('scroll-restoration-polyfill');

export default {
  name: 'app',
  data() {
    return {
    }
  },
  components: {
  },
  created:function(){
    history.scrollRestoration = 'manual';
  },
  mounted: function() {
  },
  computed:{
  },
  watch:{
  },
  methods: {
  }
}
</script>
<style lang="scss">
textarea, select, input, button { outline: none; border-style: solid;}

html {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color:white;
  font-family: 'Formular', Helvetica;
  font-size: 21px;
  font-weight: normal;
}

body {
  margin:0px;
  overscroll-behavior-y: none;
}

a, button, .fact-share>*{
  cursor: pointer;
}

img.logo{
    width:4.5rem;
    height: 2.57rem;
    min-width: 4.5rem;
    min-height: 2.57rem;
    max-width: 80px;
  //min-width: 4.5rem;
  //min-height: 2.57rem;
}

.small-text{
  font-size:0.57rem;
}
.quit-button{
  z-index: 10000;
  position:fixed;
  top:1.63rem;
  right:1.63rem;
  display:flex;
  align-items: center;
  img{
    height:1.5rem;
    width:1.5rem;
  }
}

@media (max-width: 1280px), (max-height: 1024px) {
  html {
    font-size: 16px;
  }
  #splash{
    font-size: 10px!important;
  }
  .small-text{
    font-size:0.65rem;
  }
  .fact-container{
    width: 380px !important;
  }
  .fact-link{
    left:calc(100vw - 380px) !important;
  }
  .margin-div{
    min-height:250px;
  }
}

@media (max-width: 1023px), (max-height: 600px) {
  #splash{
    font-size: 7px !important;
    padding-bottom: 2rem;
    box-sizing: border-box;
  }
  #splash h1{
    font-size: 4.5em;
  }


  .scroll-icon{
    margin-top:1em;
  }
  .splash-footer {
    font-size: 0.7rem !important;
    flex-direction: row-reverse;
  }
  .fact-single {
    font-size: 15px;
  }
  .timeline-container{
    padding-top: 1.5em!important;
    padding-bottom:1.5em!important;
    transition: 0.2s padding ease-out;
  }

  .navbar .timeline-container{
    padding-top: 4.47rem!important;
  }

  .margin-div{
    display:none;
  }

  .fact-body{
    padding-top: 3.21rem !important;
    padding-bottom: 0px !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
  }

  .fact-head{
    // display:none;
  }

  .map-link{
    display:none;
  }

  .mobile{
    display: inherit!important;
  }

  .desktop{
    display: none!important;
  }
  h1.title {
    font-size:2.26rem !important;
  }
  .timeline-container .timeline-reduced {
    //display: flex;
    // flex-direction: column-reverse;
    .panel button {
      color:white!important;
      width: 1.82rem;
      height: 1.82rem;
      border-radius: 0.91rem;
    }
    .timeline-reduced-bar-container{
      flex-grow: 1;
      pointer-events: none;
    }
    .panel{
      margin-left:0px;
    }
  }


  .timeline-container .timeline {
    margin-bottom: 0rem !important;
  }



  .small-text{
    font-size:0.8rem;
  }
  .fact-single{
    height:auto!important;
    margin-top: 0.0em;
    padding-top: 2.4em !important;
    padding-bottom: 0.0em !important;
    >div{
      min-width: 50%;
      >div{
        padding-bottom:2.4em;
      }
    }
    > div:nth-child(1){
      height:auto!important;
      flex:1;
      flex-direction: column-reverse;
      >div:nth-child(2){
        //padding-left: 2.5rem !important;
        //padding-right: 2.5rem !important;
      }
      .year {
        display:none;
      }
      img {
        max-height: 20rem !important;
        max-width: 100%;
        height:auto !important;
      }
    }
    > div:nth-child(2) {
      >div:nth-child(1){
        padding-bottom:1.6em;
      }
    }
  }
}

@media (max-width: 768px), (max-height: 384px){
  .fact-single {
    font-size: 12px;
  }
  .fact-single > div:nth-child(1) > div:nth-child(2) {
    display:flex;
    align-items: center !important;
  }
  #splash{
    font-size: 5px !important;
    h1{
      font-size:4em;
    }
  }
  #facts{
    h1{
      margin-bottom: 0rem!important;
    }
  }
  html {
    font-size: 12px;
  }
  .fact-container {
    width: 295px !important;
  }

  .fact-link{
    left:calc(100vw - 295px) !important;
  }
}

@media (max-width: 560px) {
  .fact-single >div{
    /*width:100%!important;*/
  }
  .fact-container{
    width:250px !important;
    min-width: auto !important;
    max-width: auto !important;
    align-items: center;
  }
  .fact-link{
    left:calc(100vw - 250px) !important;
  }
  .fact-single > div:nth-child(1) > div:nth-child(2) {
    padding-left:0.0rem!important;
    padding-right:0.0rem!important;
  }
  .fact-single >div{
    /*flex-direction: row!important;*/
  }
  .fact-single{
    flex-direction: column!important;
    margin-top: 1.6em !important;
    padding-top: 3.2em  !important;
    padding-bottom: none !important;
  }
  .text{
    max-width: auto!important;
    padding-bottom: 3.2em!important;
  }
  .measure{
    place-content: flex-end;
  }
}

@media (max-width: 560px) and (orientation:portrait){
  #splash-portrait{
     visibility: inherit !important;
  }
  #navbar{
    top:0px !important;
    .fact-link{
      display:none;
    }
  }
}

@font-face{
  font-family:"Formular";
  font-weight: normal;
  font-style:italic;
  src:url("./assets/fonts/5682862/44f93b41-aa13-45b5-ac44-f98936badcc3.eot?#iefix");
  src:url("./assets/fonts/5682862/44f93b41-aa13-45b5-ac44-f98936badcc3.eot?#iefix") format("eot"),url("./assets/fonts/5682862/30557ea8-8f84-4281-92cc-7c5a2a5980a3.woff2") format("woff2"),url("./assets/fonts/5682862/eae872b9-eb96-4cf4-b282-60f3296e8918.woff") format("woff"),url("./assets/fonts/5682862/a57fb875-ec8a-4596-85b6-a0a8400a62c4.ttf") format("truetype");
}
@font-face{
  font-family:"Formular";
  font-weight: normal;
  src:url("./assets/fonts/5682864/42618092-c515-4f0d-a42d-f247be208766.eot?#iefix");
  src:url("./assets/fonts/5682864/42618092-c515-4f0d-a42d-f247be208766.eot?#iefix") format("eot"),url("./assets/fonts/5682864/5eb19c7c-d001-40a2-a19a-c57069c6510e.woff2") format("woff2"),url("./assets/fonts/5682864/dd8362d9-f794-4ed1-b089-b0c4086c4cbb.woff") format("woff"),url("./assets/fonts/5682864/8d79f827-b917-412a-b869-c19c1a1536b2.ttf") format("truetype");
}

@font-face{
  font-family:"Formular-Mono";
  src:url("./assets/fonts/5682848/92a9e189-fc1d-4059-8f23-115ff48bb177.eot?#iefix");
  src:url("./assets/fonts/5682848/92a9e189-fc1d-4059-8f23-115ff48bb177.eot?#iefix") format("eot"),url("./assets/fonts/5682848/78f77eab-ffd3-4eac-a79d-328765c771fa.woff2") format("woff2"),url("./assets/fonts/5682848/738add86-0cbc-4d58-b57a-7921d297f700.woff") format("woff"),url("./assets/fonts/5682848/a8b9c3cb-9b19-427a-b2f3-f5f9ad5a0220.ttf") format("truetype");
}

@font-face{
  font-family:"Formular";
  font-weight: bold;
  font-style:italic;
  src:url("./assets/fonts/5682858/57cf95ce-73a2-455a-8814-57f8e44897fa.eot?#iefix");
  src:url("./assets/fonts/5682858/57cf95ce-73a2-455a-8814-57f8e44897fa.eot?#iefix") format("eot"),url("./assets/fonts/5682858/9184de5b-6139-421c-b1fb-3d2071885a22.woff2") format("woff2"),url("./assets/fonts/5682858/399d9dc0-3f36-4bc6-a1f4-e62eca5f970f.woff") format("woff"),url("./assets/fonts/5682858/0f40dacb-2433-4d8a-8b4c-f37dc0ee45ac.ttf") format("truetype");
}
@font-face{
  font-family:"Formular";
  font-weight: bold;
  src:url("./assets/fonts/5682860/4830682d-cc8b-4fda-8cad-f1b0a23ba7e4.eot?#iefix");
  src:url("./assets/fonts/5682860/4830682d-cc8b-4fda-8cad-f1b0a23ba7e4.eot?#iefix") format("eot"),url("./assets/fonts/5682860/916c0959-6330-4ccf-845e-448b0fe1fdf9.woff2") format("woff2"),url("./assets/fonts/5682860/05abc9cc-ce1f-46a2-87ff-a40ba01f8159.woff") format("woff"),url("./assets/fonts/5682860/a64ea2a0-621d-4764-9043-35db2257c99f.ttf") format("truetype");
}

@font-face{
  font-family:"Formular";
  font-weight: 200;
  font-style:italic;
  src:url("./assets/fonts/5682866/511b509f-d602-47be-8d6b-8c3d46132c39.eot?#iefix");
  src:url("./assets/fonts/5682866/511b509f-d602-47be-8d6b-8c3d46132c39.eot?#iefix") format("eot"),url("./assets/fonts/5682866/b4c58110-d88b-48fe-9821-3cd73db4d93b.woff2") format("woff2"),url("./assets/fonts/5682866/84d6f539-8f34-4628-8166-100ea7d6e672.woff") format("woff"),url("./assets/fonts/5682866/09503e14-7f9f-49cf-a7d9-5b38e3fafa41.ttf") format("truetype");
}
@font-face{
  font-family:"Formular";
  font-weight: 200;
  font-family:"Formular W05 Light";
  src:url("./assets/fonts/5682868/adb16d0c-22e1-4502-a55d-f4722651a251.eot?#iefix");
  src:url("./assets/fonts/5682868/adb16d0c-22e1-4502-a55d-f4722651a251.eot?#iefix") format("eot"),url("./assets/fonts/5682868/75cd550f-a833-46fc-bfee-dd4460fd28c9.woff2") format("woff2"),url("./assets/fonts/5682868/7c0943b9-99b1-4349-9cf7-4fc8f2e59591.woff") format("woff"),url("./assets/fonts/5682868/76c235ca-5590-46cf-b27f-fdd77f7755ea.ttf") format("truetype");
}




::-webkit-scrollbar {
  display: none;
}

*{
  scrollbar-width: none;
}

* {-webkit-font-smoothing: antialiased;}

</style>
